var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.096 3.241a1 1 0 011.808 0l4.42 9.33A1 1 0 0112.42 14H3.58a1 1 0 01-.904-1.428l4.42-9.33z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.333v.014M8 6.667v2",
    stroke: "#DD3636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.09626 3.2412C7.45747 2.47865 8.54253 2.47865 8.90374 3.2412L13.3235 12.5719C13.6378 13.2353 13.1539 14 12.4198 14H3.5802C2.84609 14 2.3622 13.2353 2.67646 12.5719L7.09626 3.2412Z' fill='white' stroke='white' stroke-width='2'/%3E %3Cpath d='M7.99984 11.3333V11.3466' stroke='%23DD3636' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M7.99984 6.66663V8.66663' stroke='%23DD3636' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";
export { SvgWarning as ReactComponent };